import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import HeaderComponent from '../../HeaderComponent';
import LoadingComponent from '../../LoadingComponent';
import FlexTable from '../../table/FlexTable';
import Broker from './Broker';
import Modal from '../../Modal';

import css from '../../../styles/instrument/owners';

class Brokers extends Component {
    static propTypes = {
        title: PropTypes.string,
        brokers: PropTypes.array,
        isLoading: PropTypes.bool,
        modalOpen: PropTypes.bool,
        openModal: PropTypes.func,
        closeModal: PropTypes.func,
        t: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.state = {
            showAll: false,
            expanded: null,
        };

        this.headings = [
            'MEMBER_NAME',
            'TRADES_TURNOVER',
            'BROKER_CHANGE',
        ];

        this._showAll = () => this.setState({ showAll: true });

        this._expand = id => {
            const expanded = id === this.state.expanded ? '' : id;

            this.setState({ expanded });
        };
    }

    renderModal() {
        if (!this.props.modalOpen) return null;

        return (
            <Modal
                title={this.props.t('brokerage')}
                symbol={this.props.title}
                onClick={this.props.closeModal}
            >
                <div className={css.modalWrapper}>
                    <FlexTable columns={this.headings}>
                            {this.renderFields()}
                        </FlexTable>
                </div>
            </Modal>
        );
    }

    renderFields(limit) {
        const { brokers } = this.props;

        const rows = [];

        let count = 0;

        for (const i in brokers) {
            if (brokers.hasOwnProperty(i)) {
                count++;

                const broker = brokers[i];

                if (!broker || limit && count > limit) {
                    break;
                }

                const expanded = this.state.expanded === broker.BROKER_ID;

                rows.push(
                    <Broker
                        key={i}
                        expanded={expanded}
                        onClick={this._expand}
                        {...broker}
                    />
                );
            }
        }

        return rows;
    }

    renderContent() {
        if (!this.props.brokers.length) {
            return <LoadingComponent height={319} />;
        }

        return (
            <div>
                <div className={css.tableWrapper}>
                    <FlexTable columns={this.headings}>
                        {this.renderFields(5)}
                    </FlexTable>
                </div>
                {this.renderModal()}
            </div>
        );
    }

    render() {
        if (!this.props.brokers.length && !this.props.isLoading) {
            return null;
        }

        return (
            <HeaderComponent
                title={this.props.t('brokerage')}
                label={this.props.t('common:seeAll')}
                onclick={() => this.props.openModal('brokers')}
            >
                {this.renderContent()}
            </HeaderComponent>
        );
    }
}

export default translate('stocks')(Brokers);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/brokers/Brokers.js
 **/